import { useMemo } from 'react';
import { IFormState } from '../types/calculator/form';
import { ECalculateType, EMortgageType } from '../types/calculator/enums';
/**
 * Хук для получения дефолтных значений формы
 */
export const useGetDefaultValues = (): Partial<IFormState> => {
  const defaultRegionId = '1';

  return useMemo(
    () => ({
      calculateType: ECalculateType.CostOfRealEstate,
      region: defaultRegionId,
      hasLifeInsurance: true,
      mortgageType: EMortgageType.Mortgage,
    }),
    [defaultRegionId],
  );
};
